<template>
  <div class="container-fluid">
    <div class="contents membership">
      <tab />
      <div class="tab-content" id="pills-tabContent">
        <div
          class="tab-pane fade show active"
          id="pills-1"
          role="tabpanel"
          aria-labelledby="pills-1-tab"
        >
          <!--           <div class="filter-box-4">
            <div>
              <input
                type="date"
                class="form-control-lg"
                v-model="searchData.startdate"
                name="startdate"
              />
            </div>
            <div>
              <input
                type="date"
                class="form-control-lg"
                v-model="searchData.enddate"
                name="enddate"
              />
            </div>
            <div>
              <select
                class=""
                aria-label="search select"
                v-model="searchData.searchtype"
              >
                <option value="0" selected>전체</option>
                <option value="1">인증(정회원)</option>
                <option value="2">미인증(준회원)</option>
              </select>
            </div>
            <div class="search-input">
              <input
                type="text"
                class="form-control-lg"
                placeholder="닉네임 또는 이메일"
                v-model="searchData.searchname"
              />
              <input
                class="btn btn-primary btn-lg icon-search"
                type="button"
                value=""
                @click="search"
              />
            </div>
          </div> -->

          <b-form>
            <div class="row row-cols-2 row-cols-lg-4 g-2 mb-4">
              <div class="col">
                <input
                  type="date"
                  class="form-control-lg"
                  v-model="searchData.startdate"
                  name="startdate"
                />
              </div>

              <div class="col">
                <input
                  type="date"
                  class="form-control-lg"
                  v-model="searchData.enddate"
                  name="enddate"
                />
              </div>

              <div class="col-12 col-sm-6">
                <select aria-label="" v-model="searchData.searchtype">
                  <option value="0" selected>
                    {{ $t("filter.common.total") }}
                  </option>
                  <option value="1">
                    {{ $t("filter.membership.certified") }}
                  </option>
                  <option value="2">
                    {{ $t("filter.membership.uncertified") }}
                  </option>
                </select>
              </div>

              <div class="col-12 col-sm-6">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('title.common.nickname_or_email')"
                    v-model="searchData.searchname"
                  />
                  <button
                    class="btn btn-primary btn-lg icon-search"
                    type="submit"
                    @click="search"
                  ></button>
                </div>
              </div>
            </div>
          </b-form>

          <div class="paging-box">
            <div>
              <small>
                {{ $t("text.common.total") }} :
                <span class="fw-bold text-black">{{
                  playerlistcnt | comma
                }}</span>
              </small>
            </div>
            <div>
              <!-- p>회원목록 </p -->
              <select class="sort" v-model="searchData.pagesize">
                <option value="10">{{ $t("filter.common.10perpage") }}</option>
                <option value="20">{{ $t("filter.common.20perpage") }}</option>
                <option value="30">{{ $t("filter.common.30perpage") }}</option>
                <option value="40">{{ $t("filter.common.40perpage") }}</option>
                <option value="50">{{ $t("filter.common.50perpage") }}</option>
                <option value="60">{{ $t("filter.common.60perpage") }}</option>
                <option value="70">{{ $t("filter.common.70perpage") }}</option>
                <option value="80">{{ $t("filter.common.80perpage") }}</option>
                <option value="90">{{ $t("filter.common.90perpage") }}</option>
                <option value="100">
                  {{ $t("filter.common.100perpage") }}
                </option>
              </select>
            </div>
          </div>
          <table class="table board toggle-xxl">
            <thead>
              <tr>
                <th class="col-auto d-none d-xxl-table-cell w-1">
                  {{ $t("title.main.number") }}
                </th>
                <th class="col-auto">{{ $t("title.common.nickname") }}</th>
                <th class="col-auto">{{ $t("title.common.email") }}</th>
                <th class="col-auto d-none d-lg-table-cell">
                  {{ $t("title.membership.play_count") }}
                </th>
                <th class="col-auto d-none d-xl-table-cell">
                  {{ $t("title.membership.avg_score") }}
                </th>
                <th class="col-auto d-none d-md-table-cell">
                  {{ $t("title.membership.recent_playing_date") }}
                </th>
                <th class="col-auto d-none d-xxl-table-cell">
                  {{ $t("title.membership.join_date") }}
                </th>
                <th class="col-1 w-1">
                  <input
                    type="checkbox"
                    v-model="allSelected"
                    @click="selectAll()"
                  />
                </th>
                <th class="th-arrow">&nbsp;</th>
              </tr>
            </thead>
            <tbody v-if="data_yn">
              <template v-for="(item, index) in playerlist">
                <tr :key="index">
                  <td class="col-auto d-none d-xxl-table-cell w-1">
                    {{ item.no }}
                  </td>
                  <td class="col-auto">
                    <router-link
                      :to="{
                        name: 'MemberView',
                        params: { playerno: item.playerno },
                      }"
                      class="more text-nickname text-break"
                    >
                      {{ item.nickname }}
                    </router-link>
                  </td>
                  <td class="col-auto text-break">{{ item.email }}</td>
                  <td class="col-auto d-none d-lg-table-cell">
                    {{ item.playcnt ? item.playcnt : 0 }}
                  </td>
                  <td class="col-auto d-none d-xl-table-cell">
                    {{ item.avgshot ? item.avgshot : "" }}
                  </td>
                  <!-- <td class="col-auto d-none d-lg-table-cell date" v-if="item.lastdate != null">
                    {{ $dayjs(item.lastdate).utc().format("YYYY-MM-DD H:m:s") || "" }}
                  </td>
                  <td class="col-auto d-none d-lg-table-cell date" v-else>
                    &nbsp;
                  </td> -->
                  <td class="col-auto d-none d-md-table-cell text-date">
                    {{ item.timezone_lastdate | dateformat }}
                  </td>
                  <td class="col-auto d-none d-xxl-table-cell text-date">
                    {{ item.timezone_joindate | dateformat }}
                  </td>
                  <td class="col-auto w-1">
                    <input
                      type="checkbox"
                      class="form-check-input custom-checkbox"
                      :value="index"
                      v-model="checkedPlayeridx"
                      @change="updateCheckall()"
                    />
                  </td>
                  <td class="td-arrow" @click="toggle_tr(index)">
                    <img
                      src="/img/arrow_none_collapsed.png"
                      :class="{ 'btn-toggle-arrow': view_hide === index }"
                    />
                  </td>
                </tr>
                <tr
                  class="d-xxl-none"
                  :class="{ show: view_hide === index }"
                  :key="index + 'r'"
                  v-if="view_hide === index"
                >
                  <td colspan="9">
                    <!--
                    <router-link
                      :to="{
                        name: 'MemberView',
                        params: { playerno: item.playerno },
                      }"
                      class="btn_view"
                    >
                      <img src="/img/ico_edit.png" />
                    </router-link>
                    -->
                    <div class="toggle-content">
                      <div class="row">
                        <div class="col-4">{{ $t("title.common.number") }}</div>
                        <div class="col-8">{{ item.no }}</div>
                      </div>
                      <div class="row d-lg-none">
                        <div class="col-4">
                          {{ $t("title.membership.play_count") }}
                        </div>
                        <div class="col-8">{{ item.playcnt }}</div>
                      </div>
                      <div class="row d-xl-none">
                        <div class="col-4">
                          {{ $t("title.membership.avg_score") }}
                        </div>
                        <div class="col-8">{{ item.avgshot }}</div>
                      </div>

                      <div class="row d-md-none">
                        <div class="col-4">
                          {{ $t("title.membership.recent_playing_date") }}
                        </div>
                        <div class="col-8 text-date">
                          {{ item.timezone_lastdate | dateformat }}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4">
                          {{ $t("title.membership.join_date") }}
                        </div>
                        <div class="col-8 text-date">
                          {{ item.timezone_joindate | dateformat }}
                        </div>
                      </div>
                      <!-- <div class="row">
                        <div class="col-6">Check </div>
                        <div class="col-6">
                          <input type="checkbox" class="form-check-input custom-checkbox" :value="index"
                            v-model="checkedPlayeridx" @change='updateCheckall()' />
                        </div>
                      </div> -->
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="9" class="text-center">
                  {{ $t("text.common.no_data") }}
                </td>
              </tr>
            </tbody>
          </table>
          <b-pagination-nav
            :link-gen="linkGen"
            :number-of-pages="page_total"
            v-model="searchData.pageno"
            use-router
            aria-label=""
            v-if="page_total > 1"
            first-class="prev"
            prev-class="prev"
            next-class="next"
            last-class="next"
            hide-ellipsis
            limit="10"
          >
            <template #first-text
              ><i class="material-icons"
                >keyboard_double_arrow_left</i
              ></template
            >
            <template #prev-text
              ><i class="material-icons">navigate_before</i></template
            >
            <template #next-text
              ><i class="material-icons">navigate_next</i></template
            >
            <template #last-text
              ><i class="material-icons"
                >keyboard_double_arrow_right</i
              ></template
            >
            <template #page="{ page, active }">
              <a v-if="active">{{ page }}</a>
              <a v-else>{{ page }}</a>
            </template>
          </b-pagination-nav>
          <div class="btn-bottom-wrapper">
            <b-button
              size="xl"
              variant="outline-primary"
              aria-label=""
              @click="excelSave"
              >{{ $t("button.membership.excel_download") }}</b-button
            >
            <b-button
              size="xl"
              variant="primary"
              aria-label=""
              @click="memberEmail"
              >{{ $t("button.membership.email") }}</b-button
            >
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-email"
      ref="modal-email"
      size="lg"
      centered
      scrollable
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header="{ close }">
        <h5 class="modal-title" id="exampleModalLabel">
          {{ $t("title.common.email") }}
        </h5>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="close()"
        ></b-button>
      </template>

      <div class="border-top-dgray">
        <div class="row g-0 border-bottom">
          <div class="col-sm-3 bg-gray row g-0 align-items-center">
            <label class="d-table-cell">{{ $t("title.common.from") }}</label>
          </div>
          <div class="col-sm-9">
            <input
              type="text"
              class="form-control-lg"
              readonly
              :value="checkedManagerEmail"
            />
          </div>
        </div>
        <div class="row g-0 border-bottom">
          <div class="col-sm-3 bg-gray row g-0 align-items-center">
            <label class="d-table-cell">{{ $t("title.common.to") }}</label>
          </div>
          <div class="col-sm-9">
            <input
              type="text"
              class="form-control-lg"
              readonly
              :value="checkedPlayerEmail"
            />
          </div>
        </div>
        <div class="row g-0 border-bottom">
          <div class="col-sm-3 bg-gray row g-0 align-items-center">
            <label class="d-table-cell">{{ $t("title.common.title") }}</label>
          </div>
          <div class="col-sm-9">
            <input
              type="text"
              class="form-control-lg"
              v-model="sendData.title"
            />
          </div>
        </div>
        <div class="col-sm inner border-bottom">
          <textarea
            rows="10"
            cols="30"
            :placeholder="$t('text.membership.fill_mail')"
            v-model="sendData.content"
          ></textarea>
        </div>
      </div>

      <p class="mt-2 text-subscript">
        {{ $t("text.membership.change_email_account") }}
      </p>

      <template #modal-footer="{}">
        <b-button
          size="md"
          variant="outline-secondary"
          aria-label=""
          @click="$bvModal.hide('modal-email')"
          >{{ $t("button.common.cancel") }}</b-button
        >
        <b-button
          size="md"
          variant="secondary"
          aria-label=""
          @click="sendEmail"
          >{{ $t("button.common.send_email") }}</b-button
        >
      </template>
      <!--       <template #modal-footer="{}">
        <div class="col-6 col-sm-3">
          <button
            class="btn btn-primary btn-md w-100"
            type="button"
            @click="sendEmail"
          >
            보내기
          </button>
        </div>
        <div class="col-6 col-sm-3">
          <button
            class="btn btn-outline-secondary btn-md w-100"
            type="button"
            aria-label="Close"
            @click="$bvModal.hide('modal-email')"
          >
            취소
          </button>
        </div>
      </template> -->
    </b-modal>
  </div>
</template>

<script>
import commonDataTable from "@/components/common/table/DataTable";
import commonDatePicker from "@/components/common/datepicker/Picker";
import "@/filter/common";
import ax from "@/api/member";
import axSetting from "@/api/setting";
import tab from "@/components/member/Tab";

export default {
  name: "MemberList",
  components: {
    commonDataTable,
    tab,
  },
  data() {
    return {
      playerlist: [],
      checkedPlayeridx: [],
      allSelected: false,
      checkedPlayerEmail: [],
      checkedManagerEmail: "",
      searchData: {
        startdate:
          this.$route.query.startdate ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].startdate) ||
          this.$dayjs(new Date()).add("-1", "month").format("YYYY-MM-DD"),
        enddate:
          this.$route.query.enddate ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].enddate) ||
          this.$dayjs(new Date()).format("YYYY-MM-DD"),
        searchtype:
          this.$route.query.searchtype ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchtype) ||
          1,
        searchname:
          this.$route.query.searchname ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchname) ||
          "",
        pageno:
          this.$route.query.pageno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pageno) ||
          1,
        pagesize:
          this.$route.query.pagesize ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pagesize) ||
          10,
      },
      page_total: 1,
      total_cnt: 0,
      data_yn: true,
      // pagesize: 10,
      sendData: {
        title: "",
        content: "",
        playerno: [],
        email: [],
      },
      view_hide: null,
      playerlistcnt: 0,
    };
  },
  watch: {
    "searchData.startdate": function () {
      this.searchData.pageno = 1;
      this.init();
    },
    "searchData.enddate": function () {
      this.searchData.pageno = 1;
      this.init();
    },
    "searchData.searchtype": function () {
      this.searchData.pageno = 1;
      this.init();
    },
    "searchData.searchname": function () {
      this.searchData.pageno = 1;
      this.init();
    },
    "searchData.pagesize": function () {
      this.searchData.pageno = 1;
      this.init();
    },

    "searchData.pageno": function () {
      this.init();
    },
  },
  computed: {},
  created() {
    this.init();
    axSetting.get_owneview((flag, data) => {
      if (flag) {
        this.checkedManagerEmail = data.ownerinfo.email;
      } else {
        alert(data);
      }
    });
  },
  methods: {
    init() {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      ax.memberList(this.searchData, (data) => {
        if (data) {
          if (data.playerlistcnt <= 0) {
            this.data_yn = false;
            return false;
          } else {
            this.data_yn = true;
          }

          this.playerlist = data.playerlist;
          this.playerlistcnt = data.playerlistcnt;
          this.total_cnt = data.playerlistcnt;
          this.page_total = Math.ceil(
            data.playerlistcnt / this.searchData.pagesize
          );
        } else {
          this.data_yn = false;
          this.page_total = 0;
        }
      });
    },
    selectAll() {
      this.checkedPlayeridx = [];
      this.checkedPlayerEmail = [];
      // alert(this.allSelected);
      if (!this.allSelected) {
        for (let i = 0; i < this.playerlist.length; i++) {
          //if (this.searchData.pagesize > i) {
          this.checkedPlayeridx.push(i);
          this.checkedPlayerEmail.push(
            this.playerlist[this.checkedPlayeridx[i]].email
          );
          //}
        }
      }
    },
    updateCheckall() {
      // this.allSelected = false;
      if (this.playerlist.length == this.checkedPlayeridx.length) {
        this.allSelected = true;
      } else {
        this.allSelected = false;
      }
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    startDateChange(v) {
      this.searchData.startdate = v;
    },
    endDateChange(v) {
      this.searchData.enddate = v;
    },
    search(v) {
      this.init();
    },
    memberEmail() {
      if (this.checkedPlayeridx.length < 1) {
        /*this.$notify({
          group: 'alert',
          type: 'info',
          title: '정보',
          text: '발송하려는 회원을 선택해주세요.'
        })*/
        alert(this.$i18n.t("alert.member.select_member_to_send"));
      } else {
        this.checkedPlayerEmail = [];
        for (let i = 0; i < this.checkedPlayeridx.length; i++) {
          this.checkedPlayerEmail.push(
            this.playerlist[this.checkedPlayeridx[i]].email
          );
        }
        this.$refs["modal-email"].modalOuterStyle.zIndex = 9999;
        this.$refs["modal-email"].show();
      }
    },
    sendEmail() {
      this.sendData.senderemail = this.checkedManagerEmail;
      this.sendData.email = [];
      this.sendData.playerno = [];
      for (let i = 0; i < this.checkedPlayeridx.length; i++) {
        this.sendData.email.push(
          this.playerlist[this.checkedPlayeridx[i]].email
        );
        this.sendData.playerno.push(
          this.playerlist[this.checkedPlayeridx[i]].playerno
        );
      }
      this.sendData.emailcnt = this.checkedPlayeridx.length;

      if (this.sendData.title.length < 2 || this.sendData.content.length < 2) {
        /*this.$notify({
          group: 'alert',
          type: 'info',
          title: '정보',
          text: this.$i18n.t('alert.member.input_title_contents')
        })*/
        alert(this.$i18n.t("alert.member.input_title_contents"));
        return false;
      } else {
        ax.sendEmail(this.sendData, (flag, response) => {
          if (flag) {
            /*this.$notify({
              group: 'alert',
              type: 'info',
              title: '정보',
              text: '이메일이 발송 되었습니다.'
            })*/
            alert(response.message);
            this.$refs["modal-email"].hide();
          } else {
            /*this.$notify({
              group: 'alert',
              type: 'info',
              title: '정보',
              text: '발송에 실패하였습니다.'
            })*/
            alert(response.message);
          }
        });
      }
    },
    excelSave() {
      ax.excelSave(this.searchData, (body) => {
        let tab_text =
          '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
        tab_text +=
          '<head><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
        tab_text +=
          "<xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
        tab_text += "<x:Name>Member List</x:Name>";
        tab_text +=
          "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
        tab_text += "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
        tab_text += "<table>";
        tab_text += body;
        tab_text += "</table></body></html>";

        var today = new Date();

        var year = today.getFullYear();
        var month = ("0" + (today.getMonth() + 1)).slice(-2);
        var day = ("0" + today.getDate()).slice(-2);

        var dateString = year + "-" + month + "-" + day;

        const fileName = "member".concat("_", dateString, ".xls");
        // const fileName = filename;
        const a_tag = document.createElement("a");
        const blob = new Blob([tab_text], {
          type: "application/vnd.ms-excel;charset=utf-8;",
        });
        a_tag.href = window.URL.createObjectURL(blob);
        a_tag.download = fileName;
        a_tag.click();
      });
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
};
</script>
